// extracted by mini-css-extract-plugin
export default {"menu":"shopPage_menu__oy4vV","activeMenue":"shopPage_activeMenue__SBWgg"};